module.exports = __webpack_public_path__ + "img/portrait-024.d4978fe9.jpg";